"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var LoyaltySmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,2 C12.8659932,2 16,5.13400675 16,9 C16,12.8659932 12.8659932,16 9,16 C5.13400675,16 2,12.8659932 2,9 C2,5.13400675 5.13400675,2 9,2 Z M9,3 C5.6862915,3 3,5.6862915 3,9 C3,12.3137085 5.6862915,15 9,15 C12.3137085,15 15,12.3137085 15,9 C15,5.6862915 12.3137085,3 9,3 Z M9.06359078,5.12211665 C9.17850197,5.14704065 9.26825889,5.23679758 9.2931829,5.35170877 L9.74772126,7.44734082 L11.6695524,6.496108 C11.818044,6.42261035 11.9980018,6.48340495 12.0714995,6.63189655 C12.1236591,6.7372776 12.1094468,6.86341492 12.0351455,6.95454724 L10.6801144,8.61652485 L12.6220603,9.52598898 C12.7721061,9.59625935 12.8367768,9.77486087 12.7665064,9.92490665 C12.7166372,10.0313907 12.6091579,10.0989244 12.4915816,10.0976534 L10.3473471,10.0744735 L10.8470829,12.1597895 C10.8856953,12.3209129 10.7863806,12.4828308 10.6252572,12.5214432 C10.5109117,12.5488455 10.3910994,12.5069214 10.3187856,12.4142041 L9,10.7233217 L7.68121443,12.4142041 C7.57931755,12.5448513 7.39080335,12.568158 7.26015616,12.4662612 C7.16743887,12.3939473 7.12551475,12.2741351 7.15291709,12.1597895 L7.65265285,10.0744735 L5.50841838,10.0976534 C5.34274264,10.0994444 5.20698401,9.96658954 5.20515822,9.8009138 C5.20392196,9.68333756 5.2714557,9.57585823 5.37793971,9.52598898 L7.31988559,8.61652485 L5.96485451,6.95454724 C5.86015711,6.82613341 5.87938307,6.63715941 6.00779691,6.532462 C6.09892924,6.45816068 6.22506656,6.44394842 6.33044761,6.496108 L8.25227874,7.44734082 L8.7068171,5.35170877 C8.74193732,5.18978832 8.90167033,5.08699643 9.06359078,5.12211665 Z" })));
};
LoyaltySmall.displayName = 'LoyaltySmall';
exports.default = LoyaltySmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LoyaltySmall.js.map